import React from 'react';
import { InputNumber } from 'antd';
import PropTypes from 'prop-types';

import { numberInputFormatter, numberInputParser } from 'utils';
import { Label, InfoMessage } from 'components';

const NumberField = ({
  label,
  containerClassName,
  percentage = false,
  simple = false,
  value,
  onChange,
  infoMessage,
  infoMessageClassName,
  asterisk = false,
  ...rest
}) => {
  return (
    <div className={containerClassName || ''}>
      <div className="d-flex">
        <Label label={label} asterisk={asterisk}/>
        <InfoMessage
          infoMessage={infoMessage}
          overlayClassName={infoMessageClassName}
        />
      </div>
      <InputNumber
        {...rest}
        value={percentage && value ? (value * 100).toFixed(2) : value}
        onChange={v => (percentage && value ? onChange(v / 100) : onChange(v))}
        formatter={v =>
          percentage && v
            ? `${v}%`
            : simple && v
            ? `${v}`
            : v && `${numberInputFormatter(v)}€`
        }
        parser={v =>
          percentage && v
            ? v.replace('%', '')
            : simple && v
            ? `${v}`
            : v && numberInputParser(v).replace('€', '')
        }
      />
    </div>
  );
};

NumberField.propTypes = {
  label: PropTypes.string.isRequired,
  containerClassName: PropTypes.string,
  value: PropTypes.number.isRequired,
  percentage: PropTypes.bool,
  simple: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default NumberField;
